import Vuex from 'vuex';
import Vue from 'vue';

import plans from './modules/plan';
import leftmenu from './modules/leftmenu';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    count: 0,
    rmwellDetailId: '',
    rmwellDetailMNum: '',
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    rmwellDetail(state, newObj) {
      state.rmwellDetailId = newObj.id;
      state.rmwellDetailMNum = newObj.MNum;
    },
  },
  modules: {
    plans,
    leftmenu,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js